<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h3 style="text-align: center" class="mt-2 mb-4 text-primary">
            Change password
          </h3>
          <d-alert
            v-if="sendError"
            theme="danger"
            show>
            An error occurred. Please try again.
          </d-alert>
          <d-alert
            v-if="sendErrorResult"
            theme="warning"
            show>
            {{ returnedErrors }}
          </d-alert>
          <d-alert
            v-if="sendSuccess"
            theme="success"
            show>
            Your password has been changed
          </d-alert>
          <validation-observer ref="password-reset-form" tag="form">
            <div class="form-group">
              <validation-provider
                rules="required"
                name="password"
                v-slot="{ errors }">
                <label class="text-center w-100">New password:</label>
                <d-input
                  v-model="password"
                  name="password"
                  type="password"
                  :state="errors.length ? 'invalid' : null" />
                <div class="invalid-feedback">
                    {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <validation-provider
                rules="required|password:password"
                name="password_confirmation"
                v-slot="{ errors }">
                <label class="text-center w-100">Repeat password:</label>
                <d-input
                  v-model="password_confirmation"
                  name="password_confirmation"
                  type="password"
                  :state="errors.length ? 'invalid' : null" />
                <div class="invalid-feedback">
                    {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <button
              type="submit"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="validateForm"
              :disabled="submitting">
              <template v-if="!submitting">Change password</template>
              <template v-else>Sending&hellip;</template>
            </button>
          </validation-observer>
        </div>

        <d-card-footer class="text-center">
          <router-link to="/login">
            Back to login
          </router-link>
        </d-card-footer>
      </div>
    </div>
  </div>
</template>

<script>
import FormUtils from './../utils/FormUtils.js';

export default {
  name: 'PasswordResetConfirm',
  data () {
    return {
      authError: false,
      submitting: false,
      sendSuccess: false,
      sendError: false,
      sendErrorResult: false,
      returnedErrors: '',
      password: '',
      password_confirmation: ''
    }
  },
  methods: {
    clearError () {
      this.authError = false;
    },
    validateForm () {
      FormUtils.validate(this.$refs['password-reset-form'], this.resetPassword);
    },
    resetPassword () {
      this.clearError();
      this.sendSuccess = false;
      this.sendError = false;
      this.sendErrorResult = false;
      this.submitting = true;
      this.returnedErrors = '';

      this.$http.post('/password/reset', {
        email: this.$route.params.email,
        token: this.$route.params.token,
        password: this.password,
        password_confirmation: this.password_confirmation
      }).then((response) => {
        this.submitting = false;

        if (response.data.success) {
          this.sendSuccess = true;
        } else {
          this.sendErrorResult = true;
          // eslint-disable-next-line
          this.returnedErrors = response.data.errors.join("\n");
        }
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.sendError = true;

        if (error.response) {
          this.sendErrorResult = true;
          // eslint-disable-next-line
          this.returnedErrors = Object.values(error.response.data.errors).join("\n");
        }
      });
    }
  }
}
</script>

<style scoped>
.card-body {
  white-space: pre-wrap;
}

.card-footer {
  background: #f5f5f5;
}
</style>
